import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Accordion, Table, Loader} from 'semantic-ui-react';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import TasksDetail from './tasksDetail';
import SeePartsModal from './modal/seeParts';

class OrdersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'orderSelected': {},
    };
    this.closeStockDownloadModal = this.closeStockDownloadModal.bind(this);
  }

  handleSeeComboClick(order) {
    this.setState({
      'orderSelected': order,
      'modalWasOpen': true,
    });
  }

  closeStockDownloadModal() {
    this.setState({
      'modalWasOpen': false,
      'orderSelected': {},
    });
  }

  handleRowClick(index, order) {
    this.props.taskSelected(index, order);
  }

  renderComboModal(order) {
    if (this.props.type === 'accessories') {
      return (
        <Table.Cell
          className='combo-column link'
          onClick={() => this.handleSeeComboClick(order)}
        >
          {order.combo}
        </Table.Cell>
      );
    }
  }

  fillRowBackground(workOrderStatus) {
    return !workOrderStatus ? '' :
      workOrderStatus === '40' ? 'bg-working' : 'bg-stopped';
  }

  renderAccordions() {
    const {loading, orders, technicianSelected, activeRow} = this.props;

    if (loading) {
      return <Loader active inline='centered' />;
    }

    if (!orders.length) {
      return (
        <Table striped>
          <Table.Body>
            <Table.Row textAlign='center'>
              <Table.Cell colSpan={5}>
                No hay órdenes con los parámetros de búsqueda ingresados
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return orders.map((element, index) => {
      const {type} = this.props;
      const dateFormatted = moment(element.date).format(dateFormatShow);

      return (
        <div className='accordion-row' key={index}>
          <Accordion.Title
            index={index}
            active={activeRow === index}
          >
            <Table striped className='time-market-table'>
              <Table.Body>
                <Table.Row textAlign='center' className={this.fillRowBackground(element.workOrderStatus)}>
                  <Table.Cell className='date-column'>
                    {dateFormatted}
                  </Table.Cell>
                  <Table.Cell
                    className='order-column link'
                    onClick={() => this.handleRowClick(index, element.order)}
                  >
                    {element.order}
                  </Table.Cell>
                  <Table.Cell className='description-column'>
                    {element.description}
                  </Table.Cell>
                  <Table.Cell className='chassis-column'>
                    {element.chassis}
                  </Table.Cell>
                  <Table.Cell className='color-column'>
                    {element.color}
                  </Table.Cell>
                  {this.renderComboModal(element)}
                </Table.Row>
              </Table.Body>
            </Table>
          </Accordion.Title>

          <Accordion.Content active={activeRow === index}>
            <TasksDetail
              order={element.order}
              technicianSelected={technicianSelected}
              tasks={element.tasks}
              type={type}
            />
          </Accordion.Content>
        </div>
      );
    });
  }

  render() {
    const {orderSelected, modalWasOpen} = this.state;
    return (
      <Card raised fluid>
        <SeePartsModal
          modalWasOpen={modalWasOpen}
          accessoryOrder={orderSelected}
          onCloseModal={this.closeStockDownloadModal}
        />
        <Table striped className='time-market-table'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='date-column'>Fecha</Table.HeaderCell>
              <Table.HeaderCell className='order-column'>
                Orden
              </Table.HeaderCell>
              <Table.HeaderCell className='description-column'>
                Descripción
              </Table.HeaderCell>
              <Table.HeaderCell className='chassis-column'>
                Chasis
              </Table.HeaderCell>
              <Table.HeaderCell className='color-column'>
                Color
              </Table.HeaderCell>
              {this.props.type === 'accessories' && (
                <Table.HeaderCell className='combo-column'>
                  Combo
                </Table.HeaderCell>
              )}
            </Table.Row>
          </Table.Header>
        </Table>

        <Accordion>{this.renderAccordions()}</Accordion>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.timeMarked.loading,
    'orders': state.timeMarked.orders,
  };
};

export default connect(mapStateToProps, {})(OrdersTable);
